import OSS from 'ali-oss';

const client = new OSS({
  region: process.env.REACT_APP_OSS_REGION!,
  accessKeyId: process.env.REACT_APP_OSS_ACCESS_KEY_ID!,
  accessKeySecret: process.env.REACT_APP_OSS_ACCESS_KEY_SECRET!,
  bucket: process.env.REACT_APP_OSS_BUCKET!,
  endpoint: process.env.REACT_APP_OSS_ENDPOINT!,
});

export const uploadImage = async (file: File): Promise<string> => {
  const fileName = `${process.env.REACT_APP_OSS_FOLDER!}/${Date.now()}-${file.name}`;
  const result = await client.put(fileName, file);
  return result.url;
};

export const deleteImage = async (url: string): Promise<void> => {
  const fileName = url.split('/').pop();
  if (fileName) {
    await client.delete(`${process.env.REACT_APP_OSS_FOLDER!}/${fileName}`);
  }
};

export default client;
